import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.swiper-wrapper').forEach(wrapper => {
    const container = wrapper.querySelector('.acf-innerblocks-container');
    if (container) {
      while (container.firstChild) {
        wrapper.appendChild(container.firstChild);
      }
      container.remove();
    }
  });

  const sliders = document.querySelectorAll(".carousel");

  sliders.forEach((slider) => {
    const optionsAttr = slider.getAttribute('data-swiper-options');
    let options = optionsAttr ? JSON.parse(optionsAttr) : {};

    const swiperEl = slider.querySelector('.swiper');
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    
    // If slide width is set via CSS, force slidesPerView to 'auto'
    const hasFixedWidth = slider.style.getPropertyValue('--slide-width');
    const hasFixedWidthMobile = slider.style.getPropertyValue('--slide-width-mobile');

    if (options.sameHeight) {
      slider.classList.add('has-same-height-slides');
    }

    const spaceMobile = options.spaceBetweenMobile ?? options.spaceBetween ?? 24;
    const spaceDesktop = options.spaceBetween ?? 24;

    const config = {
      loop: false,
      centeredSlides: false,
      breakpoints: {
        0: {
          slidesPerView: hasFixedWidthMobile ? 'auto' : 1,
          spaceBetween: spaceMobile,
        },
        768: {
          slidesPerView: hasFixedWidth ? 'auto' : (options.slidesPerView ?? 'auto'),
          spaceBetween: spaceDesktop,
        },
      },
    };

    if (isMobile) {
      config.navigation = {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      };
      config.pagination = {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      };
    } else {
      if (options.pagination) {
        config.pagination = {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        };
      }

      if (options.navigation) {
        config.navigation = {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        };
      }
    }

    new Swiper(
        swiperEl,
        {
            ...config,
            on: {
                init: function (swiper) {
                    // Inject slide numbers if carousel has show-numbers class
                    if (slider.classList.contains('carousel--show-numbers')) {
                      const slides = slider.querySelectorAll('.carousel-slide');
                      slides.forEach((slide, index) => {
                        const cardNumber = slide.querySelector('.card__number');
                        if (cardNumber) {
                          cardNumber.textContent = String(index + 1);
                        }
                      });
                    }
                }
            }
        }
    );
  });
  
});
